
define('text!Magento_Checkout/template/summary.html',[],function () { return '<div class="opc-block-summary" data-bind="blockLoader: isLoading"><span data-bind="i18n: \'Order summary\'" class="title"></span><!-- ko foreach: elems() --> <!-- ko template: getTemplate() --><!-- /ko --><!-- /ko --></div>';});

